import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { reducers, appEffects, metaReducers, featureKey } from './store';

export function ProvideSettings(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(featureKey, reducers, {
      metaReducers: metaReducers,
    }),
    provideEffects(appEffects),
  ]);
}
